<script>
    export let originalPrice, discountPrice;

    let MXNCurrency = new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: 0,
    });
</script>

<div class="plan-card__price-box">
    {#if discountPrice}
        <span class="plan-card__price--original"
            >{MXNCurrency.format(originalPrice)}</span
        >
        <span class="plan-card__price--discount line-height-1"
            >{MXNCurrency.format(discountPrice)}</span
        >
    {:else}
        <span class="plan-card__price--discount"
            >{MXNCurrency.format(originalPrice)}</span
        >
    {/if}
</div>
